import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/countNumber.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

$(window).resize(function(){
  if($(window).width() > 1024){
    let sec2tPt = parseInt($('.section2 .left-text').css("padding-top").replace('px', ''))
    let sec2tPb = parseInt($('.section2 .left-text').css("padding-bottom").replace('px', ''))
    let sec2tH = $('.section2 .left-text').outerHeight() - sec2tPt - sec2tPb - $('.section2 .left-text ul li').eq(0).find('.item-title').outerHeight()*3
    $('.section2 .left-text ul li .item-text').hide().css('height', sec2tH + 'px')
    $('.section2 .left-text ul li').eq(0).addClass('active').find('.item-text').slideDown()
  }else{
    $('.section2 .left-text ul li .item-text').show().css('height','auto')
  }
})

function numScroll() {
  $(".number .num").each(function(){
    let num = $(this).attr('data-num')
    $(this).empty()
    $(this).rollNum({
      deVal: num
    });
  })
}
$(document).ready(function(){
  if($(window).width() > 1024){
    let sec2tPt = parseInt($('.section2 .left-text').css("padding-top").replace('px', ''))
    let sec2tPb = parseInt($('.section2 .left-text').css("padding-bottom").replace('px', ''))
    let sec2tH = $('.section2 .left-text').outerHeight() - sec2tPt - sec2tPb - $('.section2 .left-text ul li').eq(0).find('.item-title').outerHeight()*3
    $('.section2 .left-text ul li .item-text').css('height', sec2tH + 'px')
    if(window.location.href.indexOf('#page_honor') != -1){
      $('.section2 .left-text ul li').eq(2).addClass('active').find('.item-text').slideDown()
    }else{
      $('.section2 .left-text ul li').eq(0).addClass('active').find('.item-text').slideDown()
    }
  }
  if(window.location.href.indexOf('#page_honor') != -1){
    let h
    if($(window).width() > 1024){
      h = $('.section2 .zw div').eq(2).offset().top + 100
    }else{
      h = $('.section2 .left-text li').eq(2).offset().top - 100
    }
    $(document).scrollTop(h)
  }
  numScroll()
  if($('.number').length > 0){
    var mo = new MutationObserver(function(records){
      if($(records[0].target).hasClass('is-inview')){
        numScroll()
      }
    });
  
    var element1 = document.getElementById('item1');
    mo.observe(element1, {'attributes': true});
  } 
})

//页面滚动监听
$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let contentH = $(document).height(); //内容高度

  if($(window).width() > 1024){
    let fixedTop = $('.section2').offset().top - viewH*5/100
    let fixedBtm = $('.section2').offset().top + $('.section2').outerHeight() - viewH*95/100

    if (scroH <= fixedTop) {
      $('.section2 .fixed-cont').removeClass('fixed')
    }else if (scroH > fixedTop && scroH < fixedBtm) {
      $('.section2 .fixed-cont').addClass('fixed').removeClass('abs')
    }else{
      $('.section2 .fixed-cont').addClass('abs').removeClass('fixed')
    }

    let sec2_1 =  $('.section2 .zw>div').eq(0).offset().top
    let sec2_2 =  $('.section2 .zw>div').eq(1).offset().top
    let sec2_3 =  $('.section2 .zw>div').eq(2).offset().top
    if (scroH < sec2_2) {
      swiper1.slideTo(0)
    }else if(scroH >= sec2_2 && scroH < sec2_3){
      swiper1.slideTo(1)
    }else{
      swiper1.slideTo(2)
    }
  }
  
});


var swiper1 = new Swiper(".section2 .right-swiper .mySwiper", {
  direction: 'vertical',
  speed: 800,
  on:{
    slideChangeTransitionStart: function(){
      $('.section2 .left-text ul li').eq(this.activeIndex).siblings().removeClass('active').find('.item-text').slideUp()
      $('.section2 .left-text ul li').eq(this.activeIndex).addClass('active').find('.item-text').slideDown()
      if(this.activeIndex != 2){
        $('.section2 .fixed-swiper').removeClass('active')
      }
    },
  },
})
var swiper2 = new Swiper(".section2 .fixed-swiper .mySwiper", {
  speed: 800,
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {// 分页
    el: ".section2 .fixed-swiper .swiper-pagination",
    type : 'fraction',
  },
  navigation: {//按钮
    nextEl: ".section2 .fixed-swiper .swiper-button-next",
    prevEl: ".section2 .fixed-swiper .swiper-button-prev",
  },
})

$('.section2 .left-text ul li .item-title').on('click',function(){
  let index = $(this).closest('li').index()
  let scrollT = $('.section2 .zw>div').eq(index+1).offset().top
  if($(window).width() > 1024){
    $("html, body").animate({
      scrollTop: scrollT + "px"
    }, {duration: 100,easing: "swing"});
    return false;
  }
})

$('#show-gallery').on('click',function(){
  if($(window).width() > 1024){
    $('.section2 .fixed-swiper').addClass('active')
  }else{
    let album = $('.section2 .mob-gallery a')
    if( album.length > 0){
      album.eq(0).click()
    }
  }
})
$('.section2 .fixed-swiper .close-btn').on('click',function(){
  $('.section2 .fixed-swiper').removeClass('active')
})


var swiper3 = new Swiper(".section3 .mySwiper", {
  speed: 800,
  slidesPerView : 2,
  slidesPerGroup : 2,
  spaceBetween: -40,
  breakpoints: { //响应式
    768: {  //当屏幕宽度大于等于768 
      slidesPerView: 4,
      slidesPerGroup : 4,
      spaceBetween: -40
    },
    1024: {  //当屏幕宽度大于等于768 
      slidesPerView: 4,
      slidesPerGroup : 4,
      spaceBetween: -40
    },
    1280: {  //当屏幕宽度大于等于1280
      slidesPerView: 6,
      slidesPerGroup : 6,
      spaceBetween: -40
    }
  },
  pagination: {// 分页
    el: ".section3 .swiper-pagination",
    type : 'progressbar',
  },
  navigation: {//按钮
    nextEl: ".section3 .swiper-button-next",
    prevEl: ".section3 .swiper-button-prev",
  },
})

